import Color from 'color';

import { BasicComponentProps } from '@/typings/generic';
import styled from '@emotion/styled';

const Navbar = styled.nav<BasicComponentProps>(({ theme }) => {
	return {
		top: 50,
		left: 0,
		right: 0,
		height: 48,
		backgroundColor: theme.colors.primaryNavBackground,
		zIndex: 100,
		borderBottomWidth: 1,
		borderBottomStyle: 'solid',
		borderBottomColor: Color(theme.colors.brandGrayDark).alpha(0.1).hexa(),
		[`${theme.media.desktop.sm}`]: {
			position: 'sticky',
			height: 72,
		},
		[`${theme.media.desktop.laptop}`]: {
			position: 'sticky',
			height: 72,
			boxShadow: `0px 2px 4px 0px ${theme.colors.shadow}`,
		},
	};
});

export default Navbar;
